<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <groupsidebar></groupsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <unifieddash v-if="LicensePoolID!==null" :LicensePoolID="LicensePoolID" :mode="LicensePoolGroupID"></unifieddash>
          <div v-if="LicensePoolID===null">Loading Dashboard...</div>
        </div>
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>
  </div>
</template>
<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import groupsidebar from "../../layout/Group/Sidebar.vue"
  import unifieddash from "../../components/UnifiedDash.vue"

  export default {
    name: 'GroupDashboard',
    components: {acheader,acfooter,groupsidebar,unifieddash},
    data() {
      return {
        LicensePoolGroupID: null,
        LicensePoolID:null
      }
    },
    mounted() {
      this.doPage().then(r=>{
        this.bootstrapGroup(this.$route.params.id);
        this.LicensePoolGroupID= this.$route.params.id;
        this.LicensePoolID=this.sdata.activegroup.LicensePoolID;
      });
    }
  }
</script>
